module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-2 px-4"
  }, [_c('top-area', {
    attrs: {
      "reservation": _vm.reservation
    }
  }), _vm._v(" "), (_vm.showTicketPicker) ? _c('person-ticket-selector', {
    attrs: {
      "reservation": _vm.reservation,
      "readOnly": _vm.getIsAddingReservation
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.rulesPaxBookMessage) ? _c('AlertMessage', {
    attrs: {
      "message": _vm.rulesPaxBookMessage,
      "icon": "ico-alert",
      "bold": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.rulesPendingEventMessage) ? _c('AlertMessage', {
    attrs: {
      "message": _vm.rulesPendingEventMessage,
      "icon": "ico-alert",
      "bold": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.genderPricesDependenciesMessage), function(message, index) {
    return _c('transition', {
      key: index,
      attrs: {
        "name": "fade",
        "appear": ""
      }
    }, [(message) ? _c('AlertMessage', {
      attrs: {
        "message": message,
        "icon": "ico-alert",
        "bold": ""
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.cutoffMessage) ? _c('div', {
    staticClass: "text-center color-6 radius-normal border-color-6 p-2 bg-lightest my-2"
  }, [_vm._v("\n        " + _vm._s(_vm.cutoffMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bg-lightest radius-normal border-light my-2"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('h5', {
    staticClass: "w-100"
  }, [_vm._v("\n                Customer Details \n                "), (_vm.isCustomerDetailsDataInStorage) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Fill in last customer details'),
      expression: "'Fill in last customer details'"
    }],
    staticClass: "fas fa-clipboard ml-2 bg-lighter dark text-centerpointer pointer",
    on: {
      "click": function($event) {
        return _vm.fillWithLastCustomerDetails()
      }
    }
  }) : _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('No customer details found in memory!'),
      expression: "'No customer details found in memory!'"
    }],
    staticClass: "fas fa-clipboard ml-2 bg-lighter dark text-centerpointer not-allowed",
    on: {
      "click": function($event) {
        return _vm.$toasted.error('No customer details found in memory!')
      }
    }
  })]), _vm._v(" "), _c('customer-details', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1)]), _vm._v(" "), (_vm.showBillinDetailsForm) ? _c('div', {
    staticClass: "bg-lightest radius-normal border-light mt-2 mb-2"
  }, [_c('div', {
    staticClass: "col-sm-12 pt-3"
  }, [_c('h5', {
    staticClass: "w-100"
  }, [_vm._v("Billing Details")]), _vm._v(" "), _c('billing-details', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1)]) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7f950a5e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f950a5e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details.vue
// module id = 2813
// module chunks = 0